import React, {useEffect,} from "react";
import {useHistory} from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

const PaymentStatusSuccess = () => {
 
  const history = useHistory();
 
  useEffect(() => {
    const profileUrl = localStorage.getItem("profileUrl");
    localStorage.removeItem("profileUrl");
    setTimeout(() => {
      history.push('/'+profileUrl)
    }, 2000);
  }, [])

  return (
    <div className={"statusContainer"}>
    <CircularProgress className="loader" />
      <h1 className={"H1 title"}>
        Payment succeeded
      </h1>
      <h2 className="H2">Thank you!</h2>
    </div>
  );
}

export default PaymentStatusSuccess;
